import React, { ReactElement, useEffect, useState } from 'react';
import { checkUserRole } from './rbac-utils';
import { RBACPermissions } from './rbac-types';
import { useAuth } from '../auth/auth-hooks';

export const ErrorDefaultView: React.FC = () => (
  <div>You dont have permission</div>
);

type RoleAuthorizationProps = {
  render: () => ReactElement<string | React.JSXElementConstructor<unknown>>; // eslint-disable-line @typescript-eslint/no-explicit-any
  error?: () => ReactElement<
    string | React.JSXElementConstructor<unknown>
  > | null; // eslint-disable-line @typescript-eslint/no-explicit-any
  permission?: RBACPermissions | null;
};

export const RoleAuthorizationAdmin: React.FC<RoleAuthorizationProps> = (
  {
    render,
    error = () => <ErrorDefaultView />,
    permission,
  }) => {
  const { user } = useAuth();
  const [checkAuth, setCheckAuth] = useState<boolean>(
    checkUserRole(permission),
  );
  useEffect(() => {
    setCheckAuth(checkUserRole(permission, user));
  }, [permission, user]);

  if (checkAuth) return render();
  return error();
};
